import { render } from "./TiposViajenewForm.vue?vue&type=template&id=1beac597"
import script from "./TiposViajenewForm.vue?vue&type=script&lang=js"
export * from "./TiposViajenewForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\Arenal\\ViajesControl\\Arenal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__